import LocalizedStrings from 'localized-strings';

import { ApplicantType, ApplicationType } from 'features/Onboarding/types';

export default new LocalizedStrings({
  en: {
    addAnother: {
      [ApplicantType.AccountHolder]: {
        [ApplicationType.CapitalDeposit]: 'Add another key individual',
        [ApplicationType.Standard]: 'Add another beneficial owner',
      },
      [ApplicantType.Mandatee]: {
        [ApplicationType.CapitalDeposit]:
          'Add a beneficial owner / Shareholder',
        [ApplicationType.Standard]: 'Add a beneficial owner / Shareholder',
      },
    },
    bothRole: 'Director and shareholder of at least 25% of the shares',
    bothRoleWithAmount:
      'Director and shareholder of {percentOfShares}% of the shares',
    confirmationText: {
      [ApplicantType.AccountHolder]: {
        [ApplicationType.CapitalDeposit]:
          'I’ve added all key individuals of {businessName}',
        [ApplicationType.Standard]:
          'I’ve added all beneficial owners of {businessName}',
      },
      [ApplicantType.Mandatee]: {
        [ApplicationType.CapitalDeposit]:
          'I have added all the beneficiaries/shareholders of {businessName}',
        [ApplicationType.Standard]:
          'I have added all the beneficiaries/shareholders of {businessName}',
      },
    },
    confirmationTextError: 'Please confirm',
    confirmationTextUnknownBusinessName: {
      [ApplicantType.AccountHolder]: {
        [ApplicationType.CapitalDeposit]:
          'I’ve added all key individuals of my business',
        [ApplicationType.Standard]:
          'I’ve added all beneficial owners of my business',
      },
      [ApplicantType.Mandatee]: {
        [ApplicationType.CapitalDeposit]:
          'I have added all the beneficiaries/shareholders of the company',
        [ApplicationType.Standard]:
          'I have added all the beneficiaries/shareholders of the company',
      },
    },
    ctaConfirm: 'Continue',
    ctaMissingEmails: 'Missing email(s)…',
    ctaMissingShareholders: 'Missing shareholder(s)…',
    directorRole: 'Director',
    majorShareholderRole: 'Shareholder of at least 25% of the shares',
    shareholderRoleWithAmount:
      'Shareholder of {percentOfShares}% of the shares',
  },
  fr: {
    addAnother: {
      [ApplicantType.AccountHolder]: {
        [ApplicationType.CapitalDeposit]: 'Ajouter une autre personne clé',
        [ApplicationType.Standard]: 'Ajouter un autre bénéficiaire effectif',
      },
      [ApplicantType.Mandatee]: {
        [ApplicationType.CapitalDeposit]:
          'Ajouter un bénéficiaire effectif / Actionnaire',
        [ApplicationType.Standard]:
          'Ajouter un bénéficiaire effectif / Actionnaire',
      },
    },
    bothRole: 'Dirigeant·e et actionnaire d’au moins 25 % des parts',
    bothRoleWithAmount:
      'Dirigeant·e et actionnaire de {percentOfShares} % des parts',
    confirmationText: {
      [ApplicantType.AccountHolder]: {
        [ApplicationType.CapitalDeposit]:
          'J’ai ajouté toutes les personnes clés de {businessName}',
        [ApplicationType.Standard]:
          'J’ai ajouté tous les bénéficiaires de {businessName}',
      },
      [ApplicantType.Mandatee]: {
        [ApplicationType.CapitalDeposit]:
          'J’ai ajouté tous les bénéficiaires/actionnaires de {businessName}',
        [ApplicationType.Standard]:
          'J’ai ajouté tous les bénéficiaires/actionnaires de {businessName}',
      },
    },
    confirmationTextError: 'Veuillez confirmer',
    confirmationTextUnknownBusinessName: {
      [ApplicantType.AccountHolder]: {
        [ApplicationType.CapitalDeposit]:
          'J’ai ajouté toutes les personnes clés de mon entreprise',
        [ApplicationType.Standard]:
          'J’ai ajouté tous les bénéficiaires de mon entreprise',
      },
      [ApplicantType.Mandatee]: {
        [ApplicationType.CapitalDeposit]:
          'J’ai ajouté tous les bénéficiaires/actionnaires de l’entreprise',
        [ApplicationType.Standard]:
          'J’ai ajouté tous les bénéficiaires/actionnaires de l’entreprise',
      },
    },
    ctaConfirm: 'Continuer',
    ctaMissingEmails: 'E-mail(s) manquant(s)…',
    ctaMissingShareholders: 'Actionnaire(s) manquant(s)…',
    directorRole: 'Dirigeant·e',
    majorShareholderRole: 'Actionnaire d’au moins 25 % des parts',
    shareholderRoleWithAmount: 'Actionnaire de {percentOfShares} % des parts',
  },
});
